module.exports = __webpack_public_path__ + "assets/webgl/LM_3_2.jpg.1f054544.webp";